import React from 'react';
import Dropzone from 'react-dropzone';
import { Modal } from 'react-bootstrap';
import i18next from 'i18next';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import faWarning from '@fortawesome/fontawesome-free-solid/faExclamationTriangle';
import { Redirect } from 'react-router-dom';

import { PageTitle } from '../PageTitle';
import { Message } from '../Message';
import { PageLevelAccess } from '../PageLevelAccess';
import { GroupingsService } from '../../services';
import { EntityGroupingAMTDetail } from '.';

class GroupingFloorPlan extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            deviceGroupingId: props.match.params.deviceGroupingId,
            showFloorPlanModal: false,
            showWarningModal: false,
            mapImageFound: false,
            loading: true,
            localSuccessMessage: null,
            localErrorMessage: null    
        }
    }

    componentDidMount() {
        this.refreshGrouping();
    }

    refreshGrouping() {
        GroupingsService.get(this.state.deviceGroupingId, true).then((response) => {
            this.setState({ 
                grouping: response.grouping, 
                floorPlanAMT: response.grouping.deviceGroup.groupAssociableMetadataTypes.find(amt => amt.token === 'floor_plan_location'),
                floorPlanConfigured: response.grouping.amtGroupingSupportEntries.find(entry => entry.token === 'floor_plan_image'),
                loading: false
            });
          }).catch((error) => {
            console.log(error);
          });
    }

    messageDismissCallback() {
        this.setState({
          localErrorMessage: null,
          localSuccessMessage: null
        });
    }

    toggleShowFloorPlanModal() {
        this.setState({
            showWarningModal: false,
            showFloorPlanModal: !this.state.showFloorPlanModal
        });
    }

    toggleShowWarningModal() {
        this.setState({
            showWarningModal: !this.state.showWarningModal
        });
    }

    onFloorPlanUploadDrop(files) {
        GroupingsService.uploadImageForAMT(this.state.grouping.id, this.state.floorPlanAMT.id, files[0]).then(response => {
            this.setState({
                loading: true,
                localSuccessMessage: i18next.t('messages.floor-plan-uploaded')
            }, () => this.refreshGrouping());
        }).catch(error => {
            this.setState({localErrorMessage: i18next.t('messages.floor-plan-upload-error') });
            console.error(error);
        });

        this.toggleShowFloorPlanModal();
    }

    render() {
        if (!this.state.loading) {
            if (!this.state.floorPlanAMT) {
                return ( <Redirect to={{ pathname: '/admin/groupings'}}/> );
            } else {
                const backLinkSearch = this.props.location.state && this.props.location.state.backLinkSearch ? this.props.location.state.backLinkSearch : null;
                return (
                    <div>
                        <div className="row">
                            <PageTitle 
                                title={i18next.t('pages.floor-plan.title')}
                                subTitle={this.state.grouping.name}
                                backLinkWithParams={{
                                    link: {
                                        pathname: "/admin/groupings",
                                        search: backLinkSearch
                                    }
                                }}
                            />
                        </div>
                        <Message
                            messages={{ state: { successMessage: this.state.localSuccessMessage } }}
                            errorMessage={this.state.localErrorMessage}
                            messageDismissCallback={this.messageDismissCallback.bind(this)}
                        />

                        <div className="op-content-box">
                            <div>
                                <PageLevelAccess to="/admin/groupings/edit/:deviceGroupingId">
                                    <ul className="list-inline clearfix floor-plan-heading">
                                        <li className="pull-right">
                                            <a className="btn btn-default" onClick={() => this.state.floorPlanConfigured ? this.toggleShowWarningModal() : this.toggleShowFloorPlanModal()}>
                                                {this.state.floorPlanConfigured ? i18next.t('pages.floor-plan.change-floor-plan') : i18next.t('pages.floor-plan.add-floor-plan')}
                                            </a>
                                        </li>
                                    </ul>
                                </PageLevelAccess>
                                <div>
                                    <EntityGroupingAMTDetail grouping={this.state.grouping} entities={[]} />
                                </div>
                            </div>    
                        </div>
                        <Modal show={this.state.showWarningModal} onHide={this.toggleWarningModal}>
                            <Modal.Header className='modal-warning' closeButton>
                            <Modal.Title style={{color: '#fff'}}><FontAwesomeIcon icon={faWarning} size={'lg'}/> Warning</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                            <div>
                                <p>{i18next.t('pages.floor-plan.change-prompt-warning')}</p>
                                <p>{i18next.t('messages.are-you-sure-continue')}</p>
                            </div>
                            </Modal.Body>
                            <Modal.Footer>
                                <button className="btn btn-warning" onClick={() => this.toggleShowFloorPlanModal()}>{ i18next.t('yes')}</button>
                                <button className="btn btn-default" onClick={() => this.toggleShowWarningModal()}>{ i18next.t('form-labels.cancel') }</button>
                            </Modal.Footer>
                        </Modal>
                        <Modal show={this.state.showFloorPlanModal} onHide={this.toggleShowFloorPlanModal.bind(this)}>
                            <Modal.Header closeButton>
                            <Modal.Title>{i18next.t('floor-plan-image')}</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                            <div className="floor-plan-dropzone">
                                <Dropzone className="dropzone-format" onDrop={(files) => this.onFloorPlanUploadDrop(files)}>
                                <div style={{textAlign: "center", top: "45%", position: "relative"}}> {i18next.t('pages.groups.drag-drop-floor-plan')} </div>
                                <button  style = {{margin: "0 auto", display: "block", position: "relative", top: "110px"}} className="btn btn-sm btn-default">{i18next.t('upload-an-image')}</button>
                                </Dropzone>
                            </div>
                            </Modal.Body>
                        </Modal>
                    </div>
                )
            }
        } else {
            return (
                <div className="loader">{i18next.t('loading')}</div>
            )
        }
    }
}

export default GroupingFloorPlan;